export default {
  SET_TRANSLATIONS: (state, payload) => state.translations = payload,
}